import React from 'react';

/**
 * StatCard
 * ------------------------------------------------------------------
 * A single metric tile, e.g. "Total Projects — 4". Used in a row of
 * 3 on the review step. Tone controls the background/number color.
 *
 * @param {string} label
 * @param {string|number} value
 * @param {'neutral'|'green'|'purple'} tone
 */
const CustomStatCard = ({ label, value, tone = 'neutral' }) => {
  return (
    <div className={`amok-stat-card amok-stat-card--${tone}`}>
      <span className="amok-stat-card__label">{label}</span>
      <span className="amok-stat-card__value">{value}</span>
    </div>
  );
};

export default CustomStatCard;